import { ChangeDetectionStrategy, Component, DoCheck, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { queueScheduler, scheduled, Subject, Subscription } from 'rxjs';
import { mergeAll } from 'rxjs/operators';
import { AgeFilter } from '../../covance-filter.models';
import { CovanceFilterBaseTypeComponent } from '../covance-filter-base-type.component';
import { CovanceFilterAgeType, AgeOperator, allowedAgeOperators } from './covance-filter-age-type';

@Component({
    selector: 'covance-filter-age',
    template: require('./covance-filter-age.component.html'),
    styles: [require('./covance-filter-age.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CovanceFilterAgeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterAgeType> implements OnDestroy, OnInit, DoCheck {
    @Input()
    public filterSelectionNotification: Subject<any>;

    public readonly operatorControl = new FormControl();
    public readonly dayControl = new FormControl();
    public readonly operators: AgeOperator[] = [
        {
            title: '',
            value: null,
        },
        ...allowedAgeOperators
    ];
    public readonly days = ['', '1', '2', '3', '7'];

    private readonly subscription = new Subscription();
    private filterChanged = false;
    private isRefreshed = false;

    constructor(filterAgeType: CovanceFilterAgeType) {
        super(filterAgeType);
    }

    public ngOnInit(): void {
        this.setAgeValues();
        this.subscription.add(
            scheduled(
                [
                    this.operatorControl.valueChanges,
                    this.dayControl.valueChanges
                ],
                queueScheduler,
            ).pipe(mergeAll()).subscribe(() => {
                const op = this.operatorControl.value;
                const day = this.dayControl.value;
                this.initValueChanges(op, day);
                this.isRefreshed = true;
            }),
        );

        this.subscription.add(
            this.filterSelectionNotification.subscribe(event => {
                this.filterChanged = event;
            }),
        );
    }

    public ngDoCheck() {
        if (!this.fieldVal.value && this.isRefreshed) {
            this.setAgeValues();
            this.isRefreshed = false;
        }
        if (this.filterChanged) {
            this.setAgeValues();
            this.filterChanged = false;
            this.isRefreshed = true;
        }
    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private setAgeValues() {
        const ageFilter = this.fieldVal.value as AgeFilter;
        if (ageFilter) {
            this.dayControl.setValue(ageFilter.day);
            this.operatorControl.setValue(ageFilter.operator);
        } else {
            this.dayControl.reset();
            this.operatorControl.reset();
        }
    }

    private initValueChanges(operator: string, day: string) {
        this.fieldVal.value = new AgeFilter(operator, day);
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }
}
